import { isArdoqError } from '@ardoq/common-helpers';
import { FetchError } from './types';

const isFetchError = (error: unknown): error is FetchError =>
  error instanceof FetchError;

/**
 * @deprecated Use the specific api error checks instead, ie. `api.isUnauthorized` or `api.isConflict`
 */
export const getErrorStatusCode = (error: unknown): number => {
  if (isFetchError(error)) {
    return error.getStatus();
  }
  if (isArdoqError(error)) {
    return getErrorStatusCode(error.error);
  }
  return 0;
};
